import omit from 'lodash/omit';
import Timer from '../timer';

export default {
  setSettings(state, settings) {
    state.settings = Object.assign({}, settings);
  },
  setCurrentInterval(state, {index = null, duration = null}) {
    state.currentInterval = Object.assign({}, {
      index,
      duration,
      behaviourHappenedAt: null,
      current: 0,
    });
  },
  setCurrentIntervalTime(state, time) {
    state.currentInterval.current = time;
  },
  addInterval(state) {
    let interval = Object.assign(
        {},
        omit(state.currentInterval, ['current']),
    );
    state.intervals = state.intervals.concat([interval]);
  },
  setIntervals(state, intervals) {
    state.intervals = intervals;
  },
  setCurrentIntervalBehaviourHappenedAt(state, value) {
    state.currentInterval.behaviourHappenedAt = value;
  },
  setIntervalDuration(state, {value, unitId}) {
    state.settings.intervalDurationValue = value;
    state.settings.intervalDurationUnitId = unitId;
  },
  setAuditor(state, object) {
    state.auditor = object;
  },
  setAssignee(state, object) {
    state.assignee = object;
  },
  setStartedAt(state, value) {
    state.startedAt = value;
  },
  setFinishedAt(state, value) {
    state.finishedAt = value;
  },
  setUuid(state, uuid) {
    state.uuid = uuid;
  },
  setIsSessionStarted(state, value) {
    state.isSessionStarted = value;
  },
  setShouldStartIntervalAutomatically(state, value) {
    state.shouldStartIntervalAutomatically = value;
  },
  setTimerConfig(state) {
    Timer.setCurrentTime(state.currentInterval.current);
    Timer.setTo(state.currentInterval.duration);
  },
  setIntervalEnable(state, value) {
    state.isIntervalEnable = value;
  },
};


// WEBPACK FOOTER //
// ./src/modules/dro/vuex/mutations.js